module.exports = __webpack_public_path__ + "img/room.517324d5.png";